import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import { CreateClientType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadCompanyImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createClient = (
  payload: CreateClientType
): Promise<AxiosResponse<CreateClientType>> => {
  return axios.post(`${baseURL}createClient`, payload);
};

export const deleteClient = (
  clientIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteClient`, { data: clientIds });
};

export const changeClientStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changeClientStatus/${id}`, payload);
};

export const updateClientById = (
  id: string,
  payload: CreateClientType
): Promise<AxiosResponse<CreateClientType>> => {
  return axios.patch(`${baseURL}updateClientById/${id}`, payload);
};

// export const updateCompanyClientManager = (
//   id: string,
//   payload: UpdateCompanyClientManagerType
// ): Promise<AxiosResponse<UpdateCompanyClientManagerType>> => {
//   return axios.patch(`${baseURL}updateCompanyClientManager/${id}`, payload);
// };
